import { LoadablePaint } from '@confluence/loadable';

import { ExcerptIncludeComponentShadow } from './ExcerptIncludeComponentShadow.tsx';
import type { ExcerptIncludeProps } from './types.ts';

// <LiveSearchLoader />, the children of <ExcerptIncludeLoader/>, use LoadablePaint so this has to match
export const ExcerptIncludeLoader = LoadablePaint<ExcerptIncludeProps>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ExcerptInclude" */ './ExcerptInclude.tsx'))
			.ExcerptInclude,
	// Component shadow is a subset of ExcerptIncludeProps so this would generate a TS error here as Loadable
	// expects the prop types to match.
	// @ts-expect-error
	loading: ExcerptIncludeComponentShadow,
});
